module.exports = __webpack_public_path__ + "static/media/Assist-OC_1200px.b0500f25.jpg";